module.exports = __webpack_public_path__ + "img/ic_share.f8d6883b.svg";